// extracted by mini-css-extract-plugin
module.exports = {"error":"ValidationErrors_error__1y2KR"};